var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-design-tab" },
    [
      (_vm.formData.project_type == 2 && _vm.formData.type.includes("3")) ||
      (_vm.formData.project_meeting &&
        _vm.formData.project_meeting.process_result === "1" &&
        _vm.formData.type.includes("3"))
        ? _c(
            "div",
            {
              staticClass: "sub-form-container",
              class: {
                "sub-form-disabled":
                  _vm.isTaskFormDisabled("3") || _vm.isViewTaskDisabled("3"),
                "sub-form-editing": _vm.isEditingTask("3"),
              },
            },
            [
              _c("div", { staticClass: "sub-form-title" }, [
                _vm._v("定制设计及印刷需求信息"),
              ]),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "订单业务类型",
                            prop: "items.card_and_coupon_design.order_business_type",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择" },
                              on: { change: _vm.changeOrderBusinessType },
                              model: {
                                value:
                                  _vm.formData.items.card_and_coupon_design
                                    .order_business_type,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.items.card_and_coupon_design,
                                    "order_business_type",
                                    $$v
                                  )
                                },
                                expression:
                                  "\n\t\t\t\t\t\t\tformData.items.card_and_coupon_design.order_business_type\n\t\t\t\t\t\t",
                              },
                            },
                            _vm._l(_vm.businessTypeList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.showCardTypeField
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "卡类型",
                                prop: "items.card_and_coupon_design.card_type",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "请选择",
                                    disabled:
                                      !_vm.formData.items.card_and_coupon_design
                                        .order_business_type,
                                  },
                                  model: {
                                    value:
                                      _vm.formData.items.card_and_coupon_design
                                        .card_type,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items
                                          .card_and_coupon_design,
                                        "card_type",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.items.card_and_coupon_design.card_type",
                                  },
                                },
                                _vm._l(_vm.cardTypeList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "创建订单/礼包ID",
                            prop: "items.card_and_coupon_design.order_gift_id_type",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value:
                                  _vm.formData.items.card_and_coupon_design
                                    .order_gift_id_type,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.items.card_and_coupon_design,
                                    "order_gift_id_type",
                                    $$v
                                  )
                                },
                                expression:
                                  "\n\t\t\t\t\t\t\tformData.items.card_and_coupon_design.order_gift_id_type\n\t\t\t\t\t\t",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("已创建订单"),
                              ]),
                              _c("el-radio", { attrs: { label: "2" } }, [
                                _vm._v("已创建礼包ID"),
                              ]),
                              _c("el-radio", { attrs: { label: "3" } }, [
                                _vm._v("未创建订单或礼包ID"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.formData.items.card_and_coupon_design
                    .order_gift_id_type === "1"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "订单号",
                                prop: "items.card_and_coupon_design.order_number",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  readonly: _vm.isViewTaskDisabled("3"),
                                  maxlength: 50,
                                  "show-word-limit": "",
                                  placeholder: "请输入订单号",
                                },
                                model: {
                                  value:
                                    _vm.formData.items.card_and_coupon_design
                                      .order_number,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.items.card_and_coupon_design,
                                      "order_number",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.items.card_and_coupon_design.order_number",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.items.card_and_coupon_design
                    .order_gift_id_type === "2"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "礼包ID",
                                prop: "items.card_and_coupon_design.gift_id",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  readonly: _vm.isViewTaskDisabled("3"),
                                  maxlength: 50,
                                  "show-word-limit": "",
                                  placeholder: "请输入礼包ID",
                                },
                                model: {
                                  value:
                                    _vm.formData.items.card_and_coupon_design
                                      .gift_id,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.items.card_and_coupon_design,
                                      "gift_id",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.items.card_and_coupon_design.gift_id",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "订单预计金额",
                            prop: "items.card_and_coupon_design.estimated_amount",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              readonly: _vm.isViewTaskDisabled("3"),
                              maxlength: 50,
                              "show-word-limit": "",
                              placeholder: "请输入订单预计金额",
                            },
                            model: {
                              value:
                                _vm.formData.items.card_and_coupon_design
                                  .estimated_amount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData.items.card_and_coupon_design,
                                  "estimated_amount",
                                  $$v
                                )
                              },
                              expression:
                                "formData.items.card_and_coupon_design.estimated_amount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "设计产品类型",
                            prop: "items.card_and_coupon_design.design_product_type",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择" },
                              on: { change: _vm.changeDesignProductType },
                              model: {
                                value:
                                  _vm.formData.items.card_and_coupon_design
                                    .design_product_type,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.items.card_and_coupon_design,
                                    "design_product_type",
                                    $$v
                                  )
                                },
                                expression:
                                  "\n\t\t\t\t\t\t\tformData.items.card_and_coupon_design.design_product_type\n\t\t\t\t\t\t",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "PVC卡", value: "1" },
                              }),
                              _c("el-option", {
                                attrs: { label: "生日/电影券", value: "2" },
                              }),
                              _c("el-option", {
                                attrs: { label: "提货券", value: "3" },
                              }),
                              _c("el-option", {
                                attrs: { label: "卡套", value: "4" },
                              }),
                              _c("el-option", {
                                attrs: { label: "券套", value: "5" },
                              }),
                              _c("el-option", {
                                attrs: { label: "消费券", value: "6" },
                              }),
                              _c("el-option", {
                                attrs: { label: "手提袋", value: "7" },
                              }),
                              _c("el-option", {
                                attrs: { label: "画册", value: "8" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.formData.items.card_and_coupon_design
                    .design_product_type === "1"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "卡增加磁条",
                                prop: "items.card_and_coupon_design.add_magnetic_stripe",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value:
                                      _vm.formData.items.card_and_coupon_design
                                        .add_magnetic_stripe,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items
                                          .card_and_coupon_design,
                                        "add_magnetic_stripe",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "\n\t\t\t\t\t\t\tformData.items.card_and_coupon_design.add_magnetic_stripe\n\t\t\t\t\t\t",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: "1" } }, [
                                    _vm._v("是"),
                                  ]),
                                  _c("el-radio", { attrs: { label: "2" } }, [
                                    _vm._v("否"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.items.card_and_coupon_design
                    .design_product_type === "1"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "卡尺寸",
                                prop: "items.card_and_coupon_design.card_size",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择" },
                                  on: { change: _vm.changeCardSize },
                                  model: {
                                    value:
                                      _vm.formData.items.card_and_coupon_design
                                        .card_size,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items
                                          .card_and_coupon_design,
                                        "card_size",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.items.card_and_coupon_design.card_size",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "公司标版卡尺寸：长8.5cm*宽5.4cm",
                                      value: "1",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "特殊尺寸（cm）",
                                      value: "2",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.items.card_and_coupon_design
                    .design_product_type === "1" &&
                  _vm.formData.items.card_and_coupon_design.card_size === "2"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "特殊卡尺寸",
                                prop: "items.card_and_coupon_design.card_size_custom",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  readonly: _vm.isViewTaskDisabled("3"),
                                  maxlength: 50,
                                  "show-word-limit": "",
                                  placeholder: "请输入特殊卡尺寸(cm)",
                                },
                                model: {
                                  value:
                                    _vm.formData.items.card_and_coupon_design
                                      .card_size_custom,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.items.card_and_coupon_design,
                                      "card_size_custom",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.items.card_and_coupon_design.card_size_custom",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.items.card_and_coupon_design
                    .design_product_type === "2"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "券尺寸",
                                prop: "items.card_and_coupon_design.coupon_size",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择" },
                                  on: { change: _vm.changeCouponSize },
                                  model: {
                                    value:
                                      _vm.formData.items.card_and_coupon_design
                                        .coupon_size,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items
                                          .card_and_coupon_design,
                                        "coupon_size",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.items.card_and_coupon_design.coupon_size",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "公司标版券尺寸：长12cm*宽6cm",
                                      value: "1",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "特殊尺寸（cm）",
                                      value: "2",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.items.card_and_coupon_design
                    .design_product_type === "2" &&
                  _vm.formData.items.card_and_coupon_design.coupon_size === "2"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "特殊券尺寸",
                                prop: "items.card_and_coupon_design.coupon_size_custom",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  readonly: _vm.isViewTaskDisabled("3"),
                                  maxlength: 50,
                                  "show-word-limit": "",
                                  placeholder: "请输入特殊券尺寸(cm)",
                                },
                                model: {
                                  value:
                                    _vm.formData.items.card_and_coupon_design
                                      .coupon_size_custom,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.items.card_and_coupon_design,
                                      "coupon_size_custom",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.items.card_and_coupon_design.coupon_size_custom",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.items.card_and_coupon_design
                    .design_product_type === "3"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "礼包券类型",
                                prop: "items.card_and_coupon_design.gift_coupon_type",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择" },
                                  on: { change: _vm.changeGiftCouponType },
                                  model: {
                                    value:
                                      _vm.formData.items.card_and_coupon_design
                                        .gift_coupon_type,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items
                                          .card_and_coupon_design,
                                        "gift_coupon_type",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.items.card_and_coupon_design.gift_coupon_type",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "单页（公司礼包券）",
                                      value: "1",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "双折页", value: "2" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "三折页", value: "3" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "四折页", value: "4" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "特殊要求", value: "5" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.items.card_and_coupon_design
                    .design_product_type === "3" &&
                  _vm.formData.items.card_and_coupon_design.gift_coupon_type ===
                    "1"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "礼包券尺寸",
                                prop: "items.card_and_coupon_design.gift_coupon_size",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择" },
                                  on: { change: _vm.changeGiftCouponSize },
                                  model: {
                                    value:
                                      _vm.formData.items.card_and_coupon_design
                                        .gift_coupon_size,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items
                                          .card_and_coupon_design,
                                        "gift_coupon_size",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.items.card_and_coupon_design.gift_coupon_size",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "公司礼包券尺寸：长17cm*宽9.5cm",
                                      value: "1",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "特殊展开尺寸",
                                      value: "2",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.items.card_and_coupon_design
                    .design_product_type === "3" &&
                  _vm.formData.items.card_and_coupon_design.gift_coupon_type ===
                    "1" &&
                  _vm.formData.items.card_and_coupon_design.gift_coupon_size ===
                    "2"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "特殊展开尺寸",
                                prop: "items.card_and_coupon_design.gift_coupon_size_custom",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  readonly: _vm.isViewTaskDisabled("3"),
                                  maxlength: 50,
                                  "show-word-limit": "",
                                  placeholder: "请输入特殊展开尺寸",
                                },
                                model: {
                                  value:
                                    _vm.formData.items.card_and_coupon_design
                                      .gift_coupon_size_custom,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.items.card_and_coupon_design,
                                      "gift_coupon_size_custom",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n\t\t\t\t\t\t\tformData.items.card_and_coupon_design.gift_coupon_size_custom\n\t\t\t\t\t\t",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.items.card_and_coupon_design
                    .design_product_type === "3" &&
                  ["2", "3", "4"].includes(
                    _vm.formData.items.card_and_coupon_design.gift_coupon_type
                  )
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "礼包券尺寸",
                                prop: "items.card_and_coupon_design.gift_coupon_size",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择" },
                                  on: { change: _vm.changeGiftCouponSize },
                                  model: {
                                    value:
                                      _vm.formData.items.card_and_coupon_design
                                        .gift_coupon_size,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items
                                          .card_and_coupon_design,
                                        "gift_coupon_size",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.items.card_and_coupon_design.gift_coupon_size",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "特殊展开尺寸",
                                      value: "2",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.items.card_and_coupon_design
                    .design_product_type === "3" &&
                  ["2", "3", "4"].includes(
                    _vm.formData.items.card_and_coupon_design.gift_coupon_type
                  ) &&
                  _vm.formData.items.card_and_coupon_design.gift_coupon_size ===
                    "2"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "特殊展开尺寸",
                                prop: "items.card_and_coupon_design.gift_coupon_size_custom",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  readonly: _vm.isViewTaskDisabled("3"),
                                  maxlength: 50,
                                  "show-word-limit": "",
                                  placeholder: "请输入特殊展开尺寸",
                                },
                                model: {
                                  value:
                                    _vm.formData.items.card_and_coupon_design
                                      .gift_coupon_size_custom,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.items.card_and_coupon_design,
                                      "gift_coupon_size_custom",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n\t\t\t\t\t\t\tformData.items.card_and_coupon_design.gift_coupon_size_custom\n\t\t\t\t\t\t",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.items.card_and_coupon_design
                    .design_product_type === "3" &&
                  _vm.formData.items.card_and_coupon_design.gift_coupon_type ===
                    "5"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "特殊要求",
                                prop: "items.card_and_coupon_design.gift_coupon_special_requirement",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  readonly: _vm.isViewTaskDisabled("3"),
                                  maxlength: 50,
                                  "show-word-limit": "",
                                  placeholder: "请输入特殊要求",
                                },
                                model: {
                                  value:
                                    _vm.formData.items.card_and_coupon_design
                                      .gift_coupon_special_requirement,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.items.card_and_coupon_design,
                                      "gift_coupon_special_requirement",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n\t\t\t\t\t\t\tformData.items.card_and_coupon_design\n\t\t\t\t\t\t\t\t.gift_coupon_special_requirement\n\t\t\t\t\t\t",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.items.card_and_coupon_design
                    .design_product_type === "3" &&
                  _vm.formData.items.card_and_coupon_design.gift_coupon_type ===
                    "5"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "礼包券尺寸",
                                prop: "items.card_and_coupon_design.gift_coupon_size",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择" },
                                  on: { change: _vm.changeGiftCouponSize },
                                  model: {
                                    value:
                                      _vm.formData.items.card_and_coupon_design
                                        .gift_coupon_size,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items
                                          .card_and_coupon_design,
                                        "gift_coupon_size",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.items.card_and_coupon_design.gift_coupon_size",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "特殊展开尺寸",
                                      value: "2",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.items.card_and_coupon_design
                    .design_product_type === "3" &&
                  _vm.formData.items.card_and_coupon_design.gift_coupon_type ===
                    "5" &&
                  _vm.formData.items.card_and_coupon_design.gift_coupon_size ===
                    "2"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "特殊展开尺寸",
                                prop: "items.card_and_coupon_design.gift_coupon_size_custom",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  readonly: _vm.isViewTaskDisabled("3"),
                                  maxlength: 50,
                                  "show-word-limit": "",
                                  placeholder: "请输入特殊展开尺寸",
                                },
                                model: {
                                  value:
                                    _vm.formData.items.card_and_coupon_design
                                      .gift_coupon_size_custom,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.items.card_and_coupon_design,
                                      "gift_coupon_size_custom",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n\t\t\t\t\t\t\tformData.items.card_and_coupon_design.gift_coupon_size_custom\n\t\t\t\t\t\t",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.items.card_and_coupon_design
                    .design_product_type !== "7" &&
                  _vm.formData.items.card_and_coupon_design
                    .design_product_type !== "8"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "套（卡/券/礼包券套）",
                                prop: "items.card_and_coupon_design.need_card_coupon_sleeve",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: { change: _vm.changeNeedSleeve },
                                  model: {
                                    value:
                                      _vm.formData.items.card_and_coupon_design
                                        .need_card_coupon_sleeve,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items
                                          .card_and_coupon_design,
                                        "need_card_coupon_sleeve",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "\n\t\t\t\t\t\t\tformData.items.card_and_coupon_design.need_card_coupon_sleeve\n\t\t\t\t\t\t",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: "1" } }, [
                                    _vm._v("需要卡券套"),
                                  ]),
                                  _c("el-radio", { attrs: { label: "2" } }, [
                                    _vm._v("不需要卡券套"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.items.card_and_coupon_design
                    .need_card_coupon_sleeve === "1" &&
                  (_vm.formData.items.card_and_coupon_design
                    .design_product_type === "1" ||
                    _vm.formData.items.card_and_coupon_design
                      .design_product_type === "4")
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "卡券套尺寸",
                                prop: "items.card_and_coupon_design.card_coupon_sleeve_size",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择" },
                                  on: { change: _vm.changeSleeveSize },
                                  model: {
                                    value:
                                      _vm.formData.items.card_and_coupon_design
                                        .card_coupon_sleeve_size,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items
                                          .card_and_coupon_design,
                                        "card_coupon_sleeve_size",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "\n\t\t\t\t\t\t\tformData.items.card_and_coupon_design.card_coupon_sleeve_size\n\t\t\t\t\t\t",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "卡套尺寸：10*6cm",
                                      value: "1",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "特殊尺寸（cm）",
                                      value: "2",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.items.card_and_coupon_design
                    .need_card_coupon_sleeve === "1" &&
                  ["2", "3", "5", "6"].includes(
                    _vm.formData.items.card_and_coupon_design
                      .design_product_type
                  )
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "卡券套尺寸",
                                prop: "items.card_and_coupon_design.card_coupon_sleeve_size",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择" },
                                  on: { change: _vm.changeSleeveSize },
                                  model: {
                                    value:
                                      _vm.formData.items.card_and_coupon_design
                                        .card_coupon_sleeve_size,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items
                                          .card_and_coupon_design,
                                        "card_coupon_sleeve_size",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "\n\t\t\t\t\t\t\tformData.items.card_and_coupon_design.card_coupon_sleeve_size\n\t\t\t\t\t\t",
                                  },
                                },
                                [
                                  _vm.formData.items.card_and_coupon_design
                                    .design_product_type !== "3"
                                    ? _c("el-option", {
                                        attrs: {
                                          label: "券套尺寸：13.5*7cm",
                                          value: "3",
                                        },
                                      })
                                    : _vm._e(),
                                  ["3", "5"].includes(
                                    _vm.formData.items.card_and_coupon_design
                                      .design_product_type
                                  )
                                    ? _c("el-option", {
                                        attrs: {
                                          label: "提货券券套尺寸：18.5*10cm",
                                          value: "4",
                                        },
                                      })
                                    : _vm._e(),
                                  _c("el-option", {
                                    attrs: {
                                      label: "特殊尺寸（cm）",
                                      value: "2",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.items.card_and_coupon_design
                    .need_card_coupon_sleeve === "1" &&
                  _vm.formData.items.card_and_coupon_design
                    .card_coupon_sleeve_size === "2"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "特殊卡券套尺寸",
                                prop: "items.card_and_coupon_design.card_coupon_sleeve_size_custom",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  readonly: _vm.isViewTaskDisabled("3"),
                                  maxlength: 50,
                                  "show-word-limit": "",
                                  placeholder: "请输入特殊尺寸(cm)",
                                },
                                model: {
                                  value:
                                    _vm.formData.items.card_and_coupon_design
                                      .card_coupon_sleeve_size_custom,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.items.card_and_coupon_design,
                                      "card_coupon_sleeve_size_custom",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n\t\t\t\t\t\t\tformData.items.card_and_coupon_design\n\t\t\t\t\t\t\t\t.card_coupon_sleeve_size_custom\n\t\t\t\t\t\t",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否加急设计",
                            prop: "items.card_and_coupon_design.expedited_not",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value:
                                  _vm.formData.items.card_and_coupon_design
                                    .expedited_not,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.items.card_and_coupon_design,
                                    "expedited_not",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.items.card_and_coupon_design.expedited_not",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("正常时效（预计2~3天）"),
                              ]),
                              _c("el-radio", { attrs: { label: "2" } }, [
                                _vm._v("加急（预计1~2天，加急设计费用 200元）"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否需要印刷",
                            prop: "items.card_and_coupon_design.need_printing",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.changeNeedPrinting },
                              model: {
                                value:
                                  _vm.formData.items.card_and_coupon_design
                                    .need_printing,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.items.card_and_coupon_design,
                                    "need_printing",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.items.card_and_coupon_design.need_printing",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("需要"),
                              ]),
                              _c("el-radio", { attrs: { label: "2" } }, [
                                _vm._v("不需要"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.formData.items.card_and_coupon_design.need_printing ===
                  "1"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "印刷数量",
                                prop: "items.card_and_coupon_design.printing_quantity",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  readonly: _vm.isViewTaskDisabled("3"),
                                  type: "number",
                                  min: "1",
                                  step: "1",
                                  placeholder: "请输入印刷数量",
                                },
                                on: { input: _vm.handlePrintingQuantityInput },
                                model: {
                                  value:
                                    _vm.formData.items.card_and_coupon_design
                                      .printing_quantity,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.items.card_and_coupon_design,
                                      "printing_quantity",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.items.card_and_coupon_design.printing_quantity",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.items.card_and_coupon_design.need_printing ===
                  "1"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "是否加急印刷",
                                prop: "items.card_and_coupon_design.urgent_printing",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value:
                                      _vm.formData.items.card_and_coupon_design
                                        .urgent_printing,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items
                                          .card_and_coupon_design,
                                        "urgent_printing",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.items.card_and_coupon_design.urgent_printing",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      staticStyle: { "margin-bottom": "4px" },
                                      attrs: { label: "1" },
                                    },
                                    [_vm._v("正常时效（预计7天-不含物流）")]
                                  ),
                                  _c("el-radio", { attrs: { label: "2" } }, [
                                    _vm._v(
                                      "加急（预计5天-不含物流，加急印刷费用 400元）"
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "客户logo及其他图片",
                            prop: "items.card_and_coupon_design.customer_logo",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "500px" } },
                            [
                              _c("uploadFile", {
                                ref: "cardAndCouponDesignUpload",
                                attrs: {
                                  "file-list":
                                    _vm.formData.items.card_and_coupon_design
                                      .customer_logo,
                                  limit: 9,
                                  multiple: true,
                                  disabled: _vm.isViewTaskDisabled("3"),
                                  "current-file-count":
                                    _vm.formData.items.card_and_coupon_design
                                      .customer_logo.length,
                                  source: "file",
                                  "link-url": {
                                    config:
                                      "/user/project-delivery-file/upload/config",
                                    extensions:
                                      "/user/project-delivery-file/upload/file-allow-extensions",
                                  },
                                  "only-img": false,
                                },
                                on: {
                                  emitUploadFile:
                                    _vm.handleCardAndCouponDesignFileUploaded,
                                },
                              }),
                              _c("div", { staticClass: "upload-tip" }, [
                                _vm._v("最多支持上传9个文件"),
                              ]),
                            ],
                            1
                          ),
                          _vm.formData.items.card_and_coupon_design
                            .customer_logo.length
                            ? _c(
                                "div",
                                { staticClass: "file-list" },
                                _vm._l(
                                  _vm.formData.items.card_and_coupon_design
                                    .customer_logo,
                                  function (item, idx) {
                                    return _c(
                                      "div",
                                      {
                                        key: idx,
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                          gap: "12px",
                                          "margin-bottom": "8px",
                                        },
                                      },
                                      [
                                        _vm.isImageFile(item)
                                          ? [
                                              _c("el-image", {
                                                staticStyle: {
                                                  width: "120px",
                                                  height: "80px",
                                                  "flex-shrink": "0",
                                                  border: "1px solid #ebeef5",
                                                  "border-radius": "4px",
                                                },
                                                attrs: {
                                                  src: _vm.$ossurl + item.url,
                                                  fit: "contain",
                                                  "preview-src-list":
                                                    _vm.customerLogoImageSrcList,
                                                },
                                              }),
                                            ]
                                          : _c(
                                              "span",
                                              {
                                                staticClass: "file-name",
                                                class: {
                                                  "pdf-file":
                                                    _vm.isPdfFile(item),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.isPdfFile(item) &&
                                                      _vm.openPdfFile(item)
                                                  },
                                                },
                                              },
                                              [_vm._v(_vm._s(item.file_name))]
                                            ),
                                        !_vm.isViewTaskDisabled("3")
                                          ? _c("el-button", {
                                              staticClass:
                                                "project-info-action",
                                              attrs: {
                                                type: "text",
                                                icon: "el-icon-delete",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteCardAndCouponDesignFile(
                                                    idx
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _c("el-button", {
                                          attrs: {
                                            type: "text",
                                            icon: "el-icon-download",
                                            disabled: false,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.downProjectFile(
                                                item.url,
                                                item.file_name
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      2
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "is-required",
                          attrs: {
                            label: "参考风格",
                            prop: "items.card_and_coupon_design.refer_style",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "reference-style-actions" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "project-info-action",
                                  attrs: {
                                    type: "success",
                                    disabled:
                                      _vm.isViewTaskDisabled("3") ||
                                      _vm.formData.items.card_and_coupon_design
                                        .refer_style.length >= 4,
                                  },
                                  on: { click: _vm.openReferenceStyleGallery },
                                },
                                [_vm._v("图库选择")]
                              ),
                              _c("uploadFile", {
                                ref: "referenceStyleUpload",
                                attrs: {
                                  "file-list":
                                    _vm.formData.items.card_and_coupon_design
                                      .refer_style,
                                  limit: 4,
                                  multiple: true,
                                  disabled:
                                    _vm.isViewTaskDisabled("3") ||
                                    _vm.formData.items.card_and_coupon_design
                                      .refer_style.length >= 4,
                                  "current-file-count":
                                    _vm.formData.items.card_and_coupon_design
                                      .refer_style.length,
                                  "upload-info": {
                                    file_allow_extensions: [
                                      "jpg",
                                      "jpeg",
                                      "png",
                                    ],
                                    file_size_limit: 2048,
                                  },
                                  "allow-type": ".jpg,.jpeg,.png",
                                  source: "file",
                                },
                                on: {
                                  emitUploadFile:
                                    _vm.handleReferenceStyleFileUploaded,
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "upload-tip" }, [
                            _vm._v(
                              " 仅支持jpg/jpeg/png格式，大小不超过2M，最多支持上传/选择 4张图片 "
                            ),
                          ]),
                          _vm.formData.items.card_and_coupon_design.refer_style
                            .length
                            ? _c(
                                "div",
                                { staticClass: "reference-style-list" },
                                _vm._l(
                                  _vm.formData.items.card_and_coupon_design
                                    .refer_style,
                                  function (item, idx) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.url,
                                        staticClass: "reference-style-item",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "reference-style-name",
                                            attrs: { title: item.file_name },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.file_name || "-") +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("el-image", {
                                          staticStyle: {
                                            height: "75px",
                                            width: "105px",
                                          },
                                          attrs: {
                                            src: _vm.getReferenceStyleUrl(
                                              item.url
                                            ),
                                            fit: "contain",
                                            "preview-src-list":
                                              _vm.referenceStyleImageSrcList,
                                          },
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "reference-style-file-actions",
                                          },
                                          [
                                            !_vm.isViewTaskDisabled("3")
                                              ? _c("el-button", {
                                                  staticClass:
                                                    "project-info-action",
                                                  attrs: {
                                                    type: "text",
                                                    icon: "el-icon-delete",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.deleteReferenceStyle(
                                                        idx
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                            _c("el-button", {
                                              staticClass:
                                                "project-info-action",
                                              attrs: {
                                                type: "text",
                                                icon: "el-icon-download",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.downProjectFile(
                                                    item.url,
                                                    item.file_name
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "客户需求描述",
                            prop: "items.card_and_coupon_design.customer_demand",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              readonly:
                                _vm.isTaskFormDisabled("3") ||
                                _vm.isViewTaskDisabled("3"),
                              rows: 4,
                              maxlength: 2000,
                              "show-word-limit": "",
                              placeholder: "请输入客户需求描述",
                            },
                            model: {
                              value:
                                _vm.formData.items.card_and_coupon_design
                                  .customer_demand,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData.items.card_and_coupon_design,
                                  "customer_demand",
                                  $$v
                                )
                              },
                              expression:
                                "formData.items.card_and_coupon_design.customer_demand",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.type != "add"
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "设计负责人",
                                prop: "items.card_and_coupon_design.person_charge_id",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "请选择设计负责人",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handlePersonChargeChange(
                                        _vm.formData.items
                                          .card_and_coupon_design,
                                        _vm.cardDesignPersonList
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.formData.items.card_and_coupon_design
                                        .person_charge_id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items
                                          .card_and_coupon_design,
                                        "person_charge_id",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.items.card_and_coupon_design.person_charge_id",
                                  },
                                },
                                _vm._l(
                                  _vm.cardDesignPersonList,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.name,
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.type == "view" &&
              _vm.formData.items &&
              _vm.formData.items.card_and_coupon_design
                ? _c(
                    "el-row",
                    [
                      _vm.hadInitialDesignDraft ||
                      (_vm.formData.items.card_and_coupon_design.design_draft &&
                        _vm.formData.items.card_and_coupon_design.design_draft
                          .length)
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "设计稿",
                                    prop: "items.card_and_coupon_design.design_draft",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "design-draft-upload" },
                                    [
                                      _vm.isEditingTask("3")
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  paste:
                                                    _vm.handleDesignDraftPaste,
                                                },
                                              },
                                              [
                                                _c("input", {
                                                  staticClass: "pasteInput",
                                                  attrs: {
                                                    type: "text",
                                                    placeholder: "粘贴截图上传",
                                                    maxlength: "0",
                                                  },
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                staticClass:
                                                  "el-icon-upload importFile",
                                                attrs: {
                                                  type: "primary",
                                                  disabled:
                                                    _vm.designDraftList
                                                      .length >= 9,
                                                },
                                                on: {
                                                  click:
                                                    _vm.uploadDesignDraftFile,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "上传设计稿 (" +
                                                    _vm._s(
                                                      _vm.designDraftList.length
                                                    ) +
                                                    "/9)"
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "upload-tip" },
                                              [
                                                _vm._v(
                                                  " 设计稿支持上传JPGE、JPG、PNG、PSD、PDF、ai 格式的文件 "
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm.designDraftImageList.length
                                        ? _c(
                                            "div",
                                            { staticClass: "img-style2" },
                                            _vm._l(
                                              _vm.designDraftImageList,
                                              function (item) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: "img-" + item.__index,
                                                    staticClass:
                                                      "img-style2-con",
                                                  },
                                                  [
                                                    _c("el-image", {
                                                      staticStyle: {
                                                        height: "50px",
                                                        width: "70px",
                                                      },
                                                      attrs: {
                                                        src:
                                                          _vm.$ossurl +
                                                          item.url,
                                                        fit: "contain",
                                                        "preview-src-list":
                                                          _vm.designDraftImageSrcList,
                                                      },
                                                    }),
                                                    _vm.isEditingTask("3")
                                                      ? _c("i", {
                                                          staticClass:
                                                            "el-icon-circle-close close",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.deleteDesignDraftFile(
                                                                item.__index
                                                              )
                                                            },
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                      _vm.designDraftFileList.length
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "file-list",
                                              staticStyle: { width: "45%" },
                                            },
                                            _vm._l(
                                              _vm.designDraftFileList,
                                              function (item) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: "file-" + item.__index,
                                                    staticClass: "file-item",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "file-info",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-document file-icon",
                                                        }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "file-name",
                                                            class: {
                                                              "pdf-file":
                                                                _vm.isPdfFile(
                                                                  item
                                                                ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.isPdfFile(
                                                                  item
                                                                ) &&
                                                                  _vm.openPdfFile(
                                                                    item
                                                                  )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.file_name
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c("el-button", {
                                                      attrs: {
                                                        type: "text",
                                                        icon: "el-icon-download",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.downProjectFile(
                                                            item.url,
                                                            item.file_name
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm.isEditingTask("3")
                                                      ? _c("i", {
                                                          staticClass:
                                                            "el-icon-circle-close file-close",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.deleteDesignDraftFile(
                                                                item.__index
                                                              )
                                                            },
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                      _c("uploadFile", {
                                        ref: "designDraftUpload",
                                        staticStyle: { display: "none" },
                                        attrs: {
                                          "only-img": false,
                                          "link-url": {
                                            config:
                                              "/user/project-delivery-file/upload/config",
                                            extensions:
                                              "/user/project-delivery-file/upload/file-allow-extensions",
                                          },
                                          limit: 9,
                                          multiple: true,
                                        },
                                        on: {
                                          emitUploadFile:
                                            _vm.handleDesignDraftFileUploaded,
                                        },
                                      }),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.hadInitialDesignDraft ||
                      (_vm.formData.items.card_and_coupon_design.design_draft &&
                        _vm.formData.items.card_and_coupon_design.design_draft
                          .length)
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "设计复杂度",
                                    prop: "items.card_and_coupon_design.design_complexity",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value:
                                          _vm.formData.items
                                            .card_and_coupon_design
                                            .design_complexity,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.items
                                              .card_and_coupon_design,
                                            "design_complexity",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.items.card_and_coupon_design.design_complexity",
                                      },
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("简单"),
                                      ]),
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("中级"),
                                      ]),
                                      _c("el-radio", { attrs: { label: 3 } }, [
                                        _vm._v("复杂"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showProjectInfoEditButton("3")
                ? _c("section-edit-actions", {
                    attrs: {
                      editing: _vm.isEditingTask("3"),
                      loading: _vm.editSaving,
                    },
                    on: {
                      start: function ($event) {
                        return _vm.startProjectInfoEdit("3")
                      },
                      confirm: _vm.confirmProjectInfoEdit,
                      cancel: _vm.cancelProjectInfoEdit,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c("reference-style-gallery-dialog", {
        ref: "referenceStyleGallery",
        attrs: { "form-data": _vm.formData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }